<app-long-card class="ForgotLogin">
  <ng-container *ngIf="!processComplete; else completedBlock">
    <!-- Top Controls -->
    <div class="top-controls">
      <app-language-selector></app-language-selector>
      <app-light-dark-switch></app-light-dark-switch>
    </div>

    <!-- Message -->
    <p class="welcome-subtitle">{{ "forgot.message" | translate }}</p>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label class="form-label">{{ "email" | translate }}</label>
        <input
          type="email"
          class="form-input"
          formControlName="usrEmail"
          autocomplete="off">
        <div class="form-error" *ngIf="form.controls['usrEmail'].errors && form.get('usrEmail').touched">
          {{ "error.email" | translate }}
        </div>
      </div>

      <div class="form-group">
        <label class="form-label">{{ "company" | translate }}</label>
        <input
          type="text"
          class="form-input"
          formControlName="usrLocation">
        <div class="form-error" *ngIf="form.controls['usrLocation'].errors && form.get('usrLocation').touched">
          {{ "required" | translate }}
        </div>
      </div>

      <div *ngIf="successMsg != null" class="alert alert-primary">
        {{ successMsg?.message }}
      </div>

      <button type="submit" class="btn-primary" [disabled]="!form.valid">
        <span *ngIf="isLoading$ == false; else isLoading">{{ "forgot.retreive" | translate }}</span>
        <ng-template #isLoading><mat-spinner diameter="20"></mat-spinner></ng-template>
      </button>
    </form>

    <!-- Back to Login -->
    <div class="back-to-login">
      <a [routerLink]="['/login']">{{ "login.backToLogin" | translate }}</a>
    </div>
  </ng-container>
  <ng-template #completedBlock>
    <div class="flex flex-col items-center gap-5">
      <h3 class="mb-10">{{ "ifMatching" | translate }}</h3>
      <div class="mb-30" style="max-width: 80%; text-align: center; line-height: 2;">
        {{ "checkEmail" | translate }} 
        <a color="accent" href="mailto:support@trakrsuite.com">support@trakrsuite.com</a>
      </div>
      <hr class="border-t border-[rgba(0,0,0,0.12)] my-5 w-full" />
      <div class="flex flex-col mt-30">
        <div class="mb-20">{{ "ifAdmin" | translate }}</div>
        <div class="flex flex-row justify-center items-center" >
          <div class="maxw-100" >
            <button type="button" mat-raised-button color="primary" routerLink="/login" class="w-full flex justify-center">{{ "login" | translate }}</button>
          </div>
        </div>
      </div>
      <div class="mt-30 mb-20 pl-20 pr-20">{{ "ifCounter" | translate }}</div>
    </div>
  </ng-template>
</app-long-card>
